"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(_ctx.templateClasses)
    }, [
        (0, vue_1.createElementVNode)("div", {
            class: (0, vue_1.normalizeClass)(["project-icon", _ctx.iconClass(_ctx.expansion)])
        }, null, 2),
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.modules, (module) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                class: (0, vue_1.normalizeClass)(["project-icon", module + '-icon']),
                key: module
            }, null, 2));
        }), 128))
    ], 2));
}
